import { INavigationItems } from '../interfaces/Navigation.Interface.Header'

export const SocialMediaNavigationItems: INavigationItems = [
  {
    title: 'Subscribe to email updates',
    absolute:
      'https://www.fairwork.gov.au/about-us/contact-us/subscribe-to-email-updates',
    icon: 'subscribe',
  },
  {
    title: 'Visit Fair Work on YouTube',
    absolute: 'https://www.youtube.com/user/FairWorkGovAu',
    icon: 'youtube',
  },
  {
    title: 'Visit Fair Work on Twitter',
    absolute: 'https://twitter.com/fairwork_gov_au',
    icon: 'twitter',
  },
  {
    title: 'Visit Fair Work on Facebook',
    absolute: 'https://www.facebook.com/fairwork.gov.au/',
    icon: 'facebook',
  },
  {
    title: 'Visit Fair Work on Instagram',
    absolute: 'https://www.instagram.com/fairworkgovau/',
    icon: 'icon-instagram',
  },
  {
    title: 'Visit Fair Work on LinkedIn',
    absolute:
      'https://www.linkedin.com/in/fair-work-85319387/?originalSubdomain=au',
    icon: 'linked-in',
  },
]
